import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';

export default async function fetchAddressCoords(
  address: string,
  lambdaUrl: string,
  signal?: AbortSignal,
) {
  const apiUrl = `${lambdaUrl}${getEnvironmentVar('EXPO_GOOGLE_GEOCODE_API_BASE_URL')}/json?key=${getEnvironmentVar('EXPO_GOOGLE_GEOCODE_PLACES_API_KEY')}&address=${address}`;

  return unauthenticatedFetch(apiUrl, {
    method: 'POST',
    signal,
  });
}
